import './Text.css';
import React from 'react';
import classNames from 'classnames';

interface TextProps {
  className?: string;
  weight?: string;
  size?: number;
  children?: any;
  upper?: boolean;
  color?: string;
  letterSpacing?: boolean;
  lineHeight?: number;
  preWrap?: boolean;
  noWrap?: boolean;
  lineThrough?: boolean;
  underline?: boolean;
  style?: any;
  wordBreak?: boolean;
  textAlignRight?: boolean;
}

export default function Text(
  {
    style,
    textAlignRight,
    children,
    weight,
    noWrap,
    size,
    upper,
    color = 'default',
    letterSpacing,
    className,
    lineHeight,
    preWrap,
    lineThrough,
    underline,
    wordBreak
  }: TextProps
) {
  const textClass = classNames(
    'Text',
    className,
    size && `Text-fontSize--${size}`,
    weight && `Text-fontWeight--${weight}`,
    upper && `Text-typeface--upper`,
    color && `Text-color--${color}`,
    letterSpacing && `Text-letterSpacing`,
    lineHeight && `Text-lineHeight--${lineHeight}`,
    preWrap && `Text-whiteSpace--preWrap`,
    noWrap && `Text-whiteSpace--noWrap`,
    lineThrough && `Text-lineThrough`,
    underline && `Text-underline`,
    wordBreak && 'Text-wordBreak',
    textAlignRight && 'Text-textAlignRight',
  );

  return (
    <span style={style} className={textClass}>{children}</span>
  );
}
